import { LogglyTracker } from 'loggly-jslogger'

const Logger = new LogglyTracker()

function postLogs({ message, type, mac, appVersion }) {
  let log

  if (typeof message === 'object') {
    log = JSON && JSON.stringify ? JSON.stringify(message) : message
  } else if (Array.isArray(message)) {
    log = message.join()
  } else {
    log = message
  }

  const msg = {
    type,
    message: log,
    mac,
    appVersion
  }

  Logger.push(msg)
}

export const initConsole = ({ mac, appVersion }) => {
  const logTypes = ['log', 'error', 'info', 'warning']
  const nativeConsole = {}

  Logger.push({
    logglyKey: '513d7073-1780-4aa0-9e0b-0075b98ddcb8',
    sendConsoleErrors: true,
    tag: 'javascript-logs'
  })

  for (let i = 0; i < logTypes.length; i++) {
    const type = logTypes[i]

    nativeConsole[type] = console[type]

    console[type] = function(message) {
      postLogs({ message, type, mac, appVersion })
      nativeConsole[type].apply(console, [message])
    }
  }
}
